import { Container } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { AuthFooter } from './AuthFooter';
import { AuthHeader } from './AuthHeader';
import { DarkBgLayout } from '../DarkBgLayout';

export const AuthLayout = ({ children }: { children: ReactNode }) => {
  return (
    <DarkBgLayout>
      <AuthHeader />

      <Container
        flexGrow={1}
        textAlign='center'
        maxW='800'
        display='flex'
        flexDirection='column'
        justifyContent='center'
        alignItems='center'
      >
        {children}
      </Container>
      <AuthFooter />
    </DarkBgLayout>
  );
};
